module.exports = __webpack_public_path__ + "img/report_ly_logo.21a7c9cb.png";